import React, {useState} from 'react';
import {Button, Modal, Table, theme} from "antd";
import {ColumnsType} from "antd/es/table";
import {QueryKey, useQueryClient} from "@tanstack/react-query";
import {TB_SECURITY_JWT} from "./data/TB_SECURITY_JWT";
import {useCommonUseMutation, useCommonUseQuery} from "../../../../../Common/hooks/rest/ReacQueryHook";
import {formatDate} from "../../../../../Common/util/DateUtil";
import {procAdminService} from "../../../../../Common/util/ProcService";

const JwtMgr: React.FC = () => {
    const { token: { colorBgContainer },} = theme.useToken();
    const queryClient = useQueryClient();
    const queryKey:QueryKey =   [`JwtMgr`];

    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;

    const mutateUpdate = useCommonUseMutation<any>(queryKey, queryClient
        , procAdminService);

    const { data, isFetching} = useCommonUseQuery<TB_SECURITY_JWT[]>(
        queryKey,
        () =>procAdminService<TB_SECURITY_JWT[]>("post", `${serviceCode}ADS21`, null));
    const [showConfirmBox, setShowConfirmBox] = useState<boolean>(false);

    const handleChange = () => {

        Modal.confirm({
            title: `암호화 키를 갱신하시겠습니까?`,
            content: "주의 : 확인을 누르면 현시점부터 암호화 키는 새로운 암호화 키로 로그인 토큰이 만들어집니다.",
            open: showConfirmBox,
            okText: "확인",
            cancelText: "취소",
            onOk() {
                setShowConfirmBox(false);
                const updateParam = { method: 'post', serviceCode: `${serviceCode}ADU06`, requestBody:null }
                return mutateUpdate.mutateAsync(updateParam)
                    .catch(error => {
                        console.error(error);

                    }).finally(() => {
                    });
            },
            onCancel() {
                setShowConfirmBox(false);
            },
        });

    };
    const columns: ColumnsType<TB_SECURITY_JWT> = [
        {
            title: '버전',
            dataIndex: 'jwtKeyVer',
            key: 'jwtKeyVer',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}.0
                </div>
            ,
        },
        {
            title: '로그인 암호화키',
            dataIndex: 'jwtKey',
            key: 'jwtKey',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'left', justifyContent: 'left' }}>
                    {text}
                </div>
            ,
        },
        {
            title: '로그인 활성화시간',
            dataIndex: 'jtwExpireMs',
            key: 'jtwExpireMs',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text} sec
                </div>
            ,
        },

        {
            title: 'JWT 생성일자',
            key: 'lastRegTime',
            dataIndex: 'lastRegTime',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {formatDate(text)}
                </div>
            ,
        },

    ];

    return (
        <>
        <nav style={{
            margin:'0px 0px 14px 0px',
            padding:'9px 8px 9px 0px',
            height: '50px',
            display:'flex',
            justifyContent: "space-between",
            alignItems:'center',
            borderRadius: "8px", // 라운드 처리 추가
            border: '1px solid #dadada',
            background: colorBgContainer,
        }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{
                    padding: '9px 5px',
                    display:'flex',
                }}>
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Button type="primary" size="small" onClick={handleChange}>암호갱신</Button>
            </div>
        </nav>
        <Table columns={columns}
               dataSource={data}
               rowKey="jwtKey"
               loading={isFetching}
        />
        </>
    );
};

export default JwtMgr;
